<template>
    <div class="ai-around-container">
        <div class="ai-card" v-for="(item, index) in aiCardList" :key="index"
            :class="{ even: index % 2 === 0, odd: index % 2 !== 0 }">
            <div class="ai-card-content-left">
                <div>
                    <h2 v-html="item.title"></h2>
                    <ul>
                        <li>{{ item.listOne }}</li>
                        <li v-if="item.listTwo">{{ item.listTwo }}</li>
                    </ul>
                </div>
            </div>
            <div class="ai-card-content-right">
                <img :src="item.img" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            aiCardList: [
                {
                    title: `Rapid Information<br/> Retrieval`,
                    listOne: 'Offer quick keyword search for easy data retrieval',
                    listTwo: 'Activated AI search delivers tailored AI responses',
                    img: require('@/assets/images/ai/ai-card-img1.png'),
                },
                {
                    title: 'Multi-device Support',
                    listOne: 'Multi-device Support',
                    listTwo: '',
                    img: require('@/assets/images/ai/ai-card-img2.png'),
                },
                {
                    title: 'Data Analysis',
                    listOne: 'Track widget usage, identify popular documents and search topics',
                    listTwo: 'Extract insights from customer interactions and generate data reports',
                    img: require('@/assets/images/ai/ai-card-img3.png'),
                },
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
.ai-around-container {}

.ai-card {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    border-radius: 16px;
    background-color: #fff;

    h2 {
        font-size: 30px;
        margin: 0;
        line-height: 38px;
        font-weight: bold;
    }
    &.odd {
        flex-direction: row-reverse;

    }

    ul {
        margin-top: 10px;
        padding-left: 14px;
        li {
            position: relative;
            line-height: 30px;
            font-size: 16px;

            &::before {
                content: "•";
                font-size: 24px;
                position: absolute;
                left: -14px;
                top: 0;
                bottom: 0;
                margin: auto;
                color: #189EAE;
            }
        }
    }
}

.ai-card-content-left {
    flex: 1;

    >div {
        width: 80%;
        margin: 0 auto;
    }
}

.ai-card-content-right {
    flex: 1;

    img {
        min-width: 100%;
    }
}</style>